module.exports = __webpack_public_path__ + "static/img/quancheng_05.89556c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quancheng_05.png
// module id = 2keX
// module chunks = 1